'use client';

import { ComponentProps, useEffect, useState } from 'react';
import Slider from 'react-slick';

// O react-slick gera atributos style no HTML do servidor, bloqueados pela CSP sem 'unsafe-inline'.
// Montado só no cliente, os estilos são aplicados via JavaScript, o que a CSP permite.
// Até montar, os slides ficam no HTML (para SEO) reservando o espaço, mas invisíveis.
export default function ClientSlider({ children, ...settings }: ComponentProps<typeof Slider>) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="slick-slider slick-ssr-placeholder">{children}</div>;
  }

  return <Slider {...settings}>{children}</Slider>;
}
